import { GetProductAttributeByCode } from "./types";

export const getProductAttributeByCode: GetProductAttributeByCode = ({ product }, attrCode) =>
  product.productAttributes.find(pa => pa.entity.code === attrCode);
